import React from 'react'
import './activation.css'
import { MdOutlineDone } from 'react-icons/md'
import { FaInfoCircle } from 'react-icons/fa'
import { AiOutlineMail } from 'react-icons/ai'
import SignInLink from '../user/SignInLink'

export default function ActivationDone(props) {
  
  const {title, note} = props.actData;

  return (
    <div className='activation'>
      <div className='actSuccess'><MdOutlineDone style={{color: 'greenyellow'}}/>{title}</div>
      <div className='actNote'>{note}</div>
      <div className='actSDKInfo'><MdOutlineDone style={{color: 'green'}}/>SDK Tokens can be generated per environment.</div>
      <div className='actSDKInfo'><FaInfoCircle style={{color: 'olive'}}/>Support: <AiOutlineMail/> helpdesk@kiponos.io</div>
      <hr style={{height: 2}}/>
      <div className='actSignIn'>
        <SignInLink />
      </div>
    </div>

  )
}
